import useWindowDimensions from '@lib/hooks/useWindowDimensions'
import useWindowScroll from '@react-hook/window-scroll'
import React, { FC, useEffect, useState } from 'react'
import styles from './FoldShowMore.module.scss'

type FoldShowMoreProps = { className?: string }

const FoldShowMore: FC<FoldShowMoreProps> = ({ className }) => {
  const scrollY = useWindowScroll(60)
  const { height } = useWindowDimensions()
  const [visible, setVisible] = useState<Boolean>(false)

  useEffect(() => {
    if (!visible && scrollY < height * 0.2) {
      setVisible(true)
    } else if (visible && scrollY > height * 0.2) {
      setVisible(false)
    }
  }, [scrollY, height, visible])

  return (
    <div
      className={`${styles.link} ${!visible && 'hidden'} ${
        styles.arrow
      } ${className}`}
    ></div>
  )
}

export default FoldShowMore
